import { render, staticRenderFns } from "./LinkBasicTrend.vue?vue&type=template&id=ec6277fe&"
import script from "./LinkBasicTrend.vue?vue&type=script&lang=js&"
export * from "./LinkBasicTrend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports